import { BASE_URL } from '.';
const tokenData: any = localStorage.getItem('token');
const token = tokenData;

export const api_getCategories = async (pageNo?: number, pageSize?: number) => {

	const uri = `${BASE_URL}/category/?page=${pageNo}&offset=${pageSize}`;
	console.log(uri)
	try {
		const response = await fetch(uri, {
			method: 'GET',
		});

		if (!response.ok) {
			throw new Error(`HTTP error! Status: ${response.status}`);
		}

		const data = await response.json();
		return { isSuccess: true, data };
	} catch (error) {
		console.error('Fetch error:', error);
		return { isSuccess: false, message: error };
	}
};
export const api_getCategoryById = async (id: string) => {
	const uri = `${BASE_URL}/category/${id}`;
	try {
		const response = await fetch(uri, {
			method: 'GET',
			headers: {
				authorization: `Bearer ${token}`,
			},
		});

		if (!response.ok) {
			throw new Error(`HTTP error! Status: ${response.status}`);
		}

		const data = await response.json();
		return { isSuccess: true, data };
	} catch (error) {
		console.error('Fetch error:', error);
		return { isSuccess: false, message: error };
	}
};

export const api_createCategories = async (formData: FormData) => {
	const uri = `${BASE_URL}/category`;
	try {
		const response = await fetch(uri, {
			method: 'POST',
			headers: {
				authorization: `Bearer ${token}`,
			},
			body: formData, // Ensure the formData is converted to JSON
		});

		if (!response.ok) {
			const errorData = await response.json();
			return {
				isSuccess: false,
				data: null,
				message: errorData.message || 'Failed to create the category',
			};
		}

		const data = await response.json();
		return {
			isSuccess: true,
			data,
			message: 'Category created successfully',
		};
	} catch (error) {
		return {
			isSuccess: false,
			data: null,
			message: error,
		};
	}
};

export const api_editCategories = async (categoryId: string, formData: any) => {
	const uri = `${BASE_URL}/category/${categoryId}`;
	try {
		const response = await fetch(uri, {
			method: 'PUT',
			headers: {
				authorization: `Bearer ${token}`,
			},
			body: formData,
		});

		if (!response.ok) {
			return {
				isSuccess: false,
				data: null,
				message: 'Failed to edit the category',
			};
		}

		const data = await response.json();
		return {
			isSuccess: true,
			data,
			message: 'Category edited successfully',
		};
	} catch (error) {
		return {
			isSuccess: false,
			data: null,
			message: error,
		};
	}
};

export const api_deleteCategory = async (categoryId: string) => {
	const uri = `${BASE_URL}/category/${categoryId}`;
	const response = await fetch(uri, {
		method: 'DELETE',
		headers: {
			authorization: `Bearer ${token}`,
		},
	}).then((res) => res.json());
	return response;
};
